import { ExternalReturnHubType } from "@redotech/account-common/address";
import { dropoffProviderType } from "@redotech/redo-return-core-common/dropoff-provider";
import * as z from "zod";

export const DropoffRateOptionSchema = z.object({
  provider: z.enum(dropoffProviderType),
  providerName: z.string(),
  fee: z.number().nullish(),
});
export type DropoffRateOption = z.infer<typeof DropoffRateOptionSchema>;

// Ship-to routing fields dropoff eligibility reads — a subset of the full
// address so the query keys only on what changes the answer.
export const DropoffEligibilityAddressSchema = z.object({
  country: z.string().nullish(),
  returnsCenterId: z.string().nullish(),
  blueYonderLocationId: z.string().nullish(),
  externalReturnHub: z
    .object({
      provider: z.nativeEnum(ExternalReturnHubType),
      locationId: z.string().nullish(),
    })
    .nullish(),
});
export type DropoffEligibilityAddress = z.infer<
  typeof DropoffEligibilityAddressSchema
>;

export const getDropoffOptions = {
  name: "getDropoffOptions" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    fromCountry: z.string().nullish(),
    merchantAddress: DropoffEligibilityAddressSchema.nullish(),
  }),
  output: z.object({
    dropoffOptions: z.array(DropoffRateOptionSchema),
    // True when the team has a merchant-purchasable provider enabled at all, so
    // the modal can tell "none for this address" from "dropoff isn't set up".
    dropoffEnabledForTeam: z.boolean(),
  }),
};
